import L from 'leaflet';
import avatarColor, { initialOf } from './avatarColor';

/**
 * Kartmarkorer.
 *
 * Ritas som divIcon med egen HTML i stallet for bildfiler: inget hamtas
 * utifran, formen kan folja appens formsprak, och en van kan visas med sin
 * profilbild i stallet for en anonym nal.
 */

const escapeHtml = (value = '') => String(value).replace(/[&<>"']/g, (c) => (
  { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
));

const LIME = '#c8ff2e';
const OFF_WHITE = '#f1efe8';

/** Rund bricka med en liten spets nedat — grunden for alla markorer. */
function badge({ inner, color, size = 44, className = '' }) {
  const html = `
    <div class="pin ${className}" style="--pin-color:${color};--pin-size:${size}px">
      <div class="pin__body">${inner}</div>
      <div class="pin__tail"></div>
    </div>`;

  return L.divIcon({
    html,
    className: 'pin-wrapper',
    iconSize: [size, size + 10],
    // Spetsen, inte mitten, ska peka pa koordinaten.
    iconAnchor: [size / 2, size + 10],
    popupAnchor: [0, -(size + 6)],
    tooltipAnchor: [0, -(size + 4)],
  });
}

/** Van: profilbilden, eller initialen mot personens egen farg. */
export function friendMarker({ username, picture }) {
  const color = avatarColor(username || '');
  const inner = picture
    ? `<img class="pin__image" src="${escapeHtml(picture)}" alt="" />`
    : `<span class="pin__initial">${escapeHtml(initialOf(username))}</span>`;

  return badge({ inner, color, size: 46, className: 'pin--friend' });
}

/** Traff: en bricka med bil. */
export function meetMarker() {
  return badge({ inner: '<span class="pin__glyph">🚗</span>', color: LIME, size: 40 });
}

/** Destination: malflagga. */
export function destinationMarker() {
  return badge({ inner: '<span class="pin__glyph">🏁</span>', color: OFF_WHITE, size: 38 });
}

/** Symbol per platstyp. */
const PLACE_GLYPHS = {
  parking: 'P',
  fuel: '\u26FD',
  repair: '\u{1F527}',
};

/**
 * Plats i narheten: samma bricka som ovriga markorer, men i lime for att
 * hora ihop med filtret man valt. Vald plats blir storre.
 */
export function placeMarker(category, selected = false) {
  const glyph = PLACE_GLYPHS[category] || '\u25CF';
  const isLetter = category === 'parking';

  return badge({
    inner: `<span class="${isLetter ? 'pin__letter' : 'pin__glyph'}">${glyph}</span>`,
    color: LIME,
    size: selected ? 46 : 36,
    className: selected ? 'pin--place pin--selected' : 'pin--place',
  });
}

/**
 * Egen position: ingen nal, utan den blaa punkten man kanner igen fran
 * kartappar, med en lugn puls omkring sig.
 */
export function selfMarker() {
  return L.divIcon({
    html: '<div class="self-dot"><span class="self-dot__pulse"></span><span class="self-dot__core"></span></div>',
    className: 'pin-wrapper',
    iconSize: [22, 22],
    iconAnchor: [11, 11],
    popupAnchor: [0, -14],
  });
}
